import * as constants from './pointShop.constants';

export const getPointShopItems = () => ({ type: constants.GET_POINT_SHOP_ITEMS });
export const deletePointShopItem = (id) => ({ type: constants.DELETE_POINT_SHOP_ITEM, id });
export const getPointShopAnalysis = () => ({ type: constants.GET_POINT_SHOP_ITEMS_ANALYSIS });
export const getPointShopItem = (hubId) => ({type: constants.GET_POINT_SHOP_ITEM, hubId});
export const clearPointShopItemData = () => ({type: constants.CLEAR_POINT_SHOP_ITEM_DATA});
export const ClearPointShopItemImageError = () => ({ type: constants.CLEAR_POINT_SHOP_ITEM_IMAGE_ERROR });
